import React from 'react';
import c from 'classnames';

import { Loader as BaseLoader, Stack } from '@lyearn/ui';

import { loaderStyles } from './styles';

export default function Loader() {
  return (
    <Stack alignItems="center" className={c('w-full', loaderStyles)} justifyContent="center">
      <BaseLoader />
    </Stack>
  );
}
